// extracted by mini-css-extract-plugin
export default {"SignRate":"_SignRate--uRNWb","Divider":"_Divider--kZoJr","SignRateHeader":"_SignRateHeader--FzVVL"};